export default function StatCard({ label, value, sublabel, accent, testId }) {
  return (
    <div
      data-testid={testId}
      className="bg-white rounded-xl border border-sif p-4 sm:p-5 card-shadow flex flex-col justify-between"
    >
      <div className="text-[11px] sm:text-xs text-sif-muted uppercase tracking-wider font-medium truncate">{label}</div>
      <div className={`mt-1.5 sm:mt-2 text-xl sm:text-2xl font-bold break-words ${accent || "text-sif-primary"}`}>{value}</div>
      {sublabel && <div className="mt-1 text-[11px] sm:text-xs text-sif-muted truncate">{sublabel}</div>}
    </div>
  );
}
